import React, { useEffect, useState } from "react";
import {
  CircleUserRound,
  LogOut,
  Repeat,
  Menu,
  ShoppingCart,
  Bell,
  DollarSign,
  BadgeDollarSign,
} from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import { useLocation, useNavigate } from "react-router-dom";
import { useSidebar } from "../ui/sidebarNew";
import { ROUTES } from "../Constants/routesConstant";
import { getHeaderTitle, UserInitialName } from "../Constants/AppConstant";
import { Button } from "../ui/button";
import { accountService } from "../../Services";
import { cartutils } from "../../Helpers";

const AppNavbar = ({
  user,
  setModal,
  profiles,
  NotifModul,
  setModalNotification,
  closeCartPanel,
  cartItem,
  customTitle,
}) => {
  const location = useLocation();
  const pathname = location.pathname;
  const { toggleSidebar } = useSidebar();
  const navigate = useNavigate();
  const headerTitle = getHeaderTitle(pathname, customTitle);
  const [cartItemCount, setCartItemCount] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);

  const data = user ? (user?.data ? user?.data : null) : null;
  const isBrand = data?.active_role === 3;

  let profilePath = ``;
  const roleId = data
    ? data["roles"]?.length > 0
      ? data["roles"]?.filter((item) => item["id"] === data["active_role"])[0]?.[
          "id"
        ]
      : ""
    : "";
  if (data) {
    if (roleId === 1) {
      profilePath = `/influencer/profile`;
    } else if (roleId === 3) {
      profilePath = `/brand/profile`;
    } else if (roleId === 2) {
      profilePath = `/admin/profile`;
    }
  }

  useEffect(() => {
    if (user) {
      let getcartItem = cartutils.getCartItemInArray(user.data.id);
      if (getcartItem) {
        setCartItemCount(getcartItem?.length > 0 ? getcartItem?.length : 0);
      } else {
        setCartItemCount(0);
      }
    } else {
      setCartItemCount(0);
    }
  }, [cartItem, user]);

  // 👇 scroll listener for shadow + border
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleProfile = () => {
    navigate(profilePath || ROUTES.MY_PROFILE);
  };

  const logout = () => {
    accountService.logout(() => {
      navigate("/account/login");
    });
  };

  const handlePayment = () => {
    navigate("/influencer/payment");
  };

  return (
    <header
      className={`flex h-16 items-center justify-between px-4 md:px-6 transition-all duration-300 ${
        isBrand
          ? `bg-green-50 backdrop-blur-sm ${
              isScrolled
                ? "border-b border-b-green-200 shadow-md"
                : "border-b border-b-green-200 shadow-sm"
            }`
          : ""
      }`}
      style={
        !isBrand
          ? {
              background: "rgba(255, 255, 255, 0.95)",
              backdropFilter: "blur(12px)",
              borderBottom: isScrolled
                ? "1px solid #d1d5db"
                : "1px solid #e5e7eb",
              boxShadow: isScrolled
                ? "0 4px 20px rgba(0, 0, 0, 0.08)"
                : "0 2px 10px rgba(0, 0, 0, 0.04)",
            }
          : {}
      }
    >
      <div className="flex items-center flex-1">
        <button
          className={`mr-2 md:hidden p-2 rounded-full transition-all duration-200 ${
            isBrand ? "hover:bg-green-800" : ""
          }`}
          style={
            !isBrand
              ? {
                  color: "#94a3b8",
                }
              : {}
          }
          onMouseEnter={(e) => {
            if (!isBrand) {
              e.currentTarget.style.background = "rgba(16, 185, 129, 0.15)";
              e.currentTarget.style.color = "#10b981";
            }
          }}
          onMouseLeave={(e) => {
            if (!isBrand) {
              e.currentTarget.style.background = "transparent";
              e.currentTarget.style.color = "#94a3b8";
            }
          }}
          onClick={() => toggleSidebar()}
        >
          <Menu className={`w-6 h-6 ${isBrand ? "text-white" : ""}`} />
        </button>
        <h1
          className={`text-xl font-semibold truncate ${
            isBrand ? "text-green-900" : ""
          }`}
          style={
            !isBrand
              ? {
                  background:
                    "linear-gradient(90deg, #059669, #10b981, #34d399)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }
              : {}
          }
        >
          {headerTitle}
        </h1>
      </div>

      <div className="flex items-center gap-3">
        {data && data?.active_role && data?.active_role === 1 && (
          <button
            className={`p-2 rounded-full transition-all duration-200 relative ${
              isBrand
                ? "hover:bg-green-100"
                : "text-slate-500 hover:text-emerald-600 hover:bg-emerald-50"
            }`}
            onClick={() => handlePayment()}
          >
            <BadgeDollarSign
              className={`w-5 h-5 ${isBrand ? "text-green-900" : ""}`}
            />
          </button>
        )}
        {data && data?.active_role && data?.active_role === 3 && (
          <button
            className="p-2 hover:bg-green-100 rounded-full transition-colors relative"
            onClick={() => closeCartPanel && closeCartPanel()}
          >
            <ShoppingCart className="w-5 h-5 text-green-900" />
            {cartItemCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-green-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                {cartItemCount}
              </span>
            )}
          </button>
        )}
        <button
          className={`p-2 rounded-full transition-all duration-200 relative ${
            isBrand
              ? "hover:bg-green-100"
              : "text-slate-500 hover:text-emerald-600 hover:bg-emerald-50"
          }`}
          onClick={() =>
            setModalNotification && setModalNotification("notifications")
          }
        >
          <Bell className={`w-5 h-5 ${isBrand ? "text-green-900" : ""}`} />
          {NotifModul &&
            NotifModul?.length > 0 &&
            NotifModul[0]?.activeNotification !== 0 && (
              <span
                className="absolute top-1.5 right-1.5 w-2 h-2 rounded-full bg-emerald-500"
                style={{
                  border: "2px solid white",
                  boxShadow: "0 0 6px rgba(16, 185, 129, 0.4)",
                }}
              ></span>
            )}
        </button>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="ghost"
              className={`flex items-center space-x-2 rounded-xl p-2 border-none ring-transparent transition-all duration-200 ${
                isBrand
                  ? "bg-green-800 hover:bg-green-700"
                  : "hover:bg-slate-100"
              }`}
              style={
                !isBrand
                  ? {
                      background: "rgba(241, 245, 249, 0.8)",
                      border: "1px solid #e2e8f0",
                    }
                  : {}
              }
            >
              <Avatar className="h-8 w-8 ring-2 ring-emerald-500/20">
                <AvatarImage src="/path-to-avatar.jpg" alt="User Avatar" />
                <AvatarFallback
                  className="!text-white"
                  style={{
                    background: "linear-gradient(135deg, #10b981, #059669)",
                    boxShadow: "0 2px 8px rgba(16, 185, 129, 0.25)",
                  }}
                >
                  {data?.firstName && data?.lastName
                    ? UserInitialName(data?.firstName, data?.lastName)
                    : data?.active_role === 3
                    ? "BR"
                    : data?.active_role === 1
                    ? "IF"
                    : ""}
                </AvatarFallback>
              </Avatar>
              <span
                className={`hidden text-sm font-bold md:block ${
                  isBrand ? "text-white" : "text-slate-700"
                }`}
              >
                {data && data.firstName ? data.firstName : "BRAND"}{" "}
                {data && data.lastName ? data.lastName : ""}
              </span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            align="end"
            className="w-56 rounded-xl border bg-white shadow-lg"
            style={{
              borderColor: "#e2e8f0",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
            }}
          >
            <DropdownMenuItem
              className="flex items-center gap-3 px-3 py-2 cursor-pointer rounded-lg mx-1 my-0.5 text-slate-700 hover:bg-emerald-50 hover:text-emerald-700 transition-all duration-200"
              onClick={() => handleProfile()}
            >
              <CircleUserRound className="w-5 h-5 text-emerald-600" />
              <span className="block w-full text-sm">
                {roleId === 1 ? "My Info" : "My Info"}
              </span>
            </DropdownMenuItem>
            {data && data?.active_role && data?.active_role === 3 && (
              <DropdownMenuItem
                className="flex items-center gap-3 px-3 py-2 cursor-pointer rounded-lg mx-1 my-0.5 text-slate-700 hover:bg-emerald-50 hover:text-emerald-700 transition-all duration-200"
                onClick={() => navigate("/brand/billing")}
              >
                <DollarSign className="w-5 h-5 text-emerald-600" />
                <span className="block w-full text-sm">Billing</span>
              </DropdownMenuItem>
            )}
            {data?.roles && data?.roles?.length > 1 && (
              <DropdownMenuItem
                className="flex items-center gap-3 px-3 py-2 cursor-pointer rounded-lg mx-1 my-0.5 text-slate-700 hover:bg-emerald-50 hover:text-emerald-700 transition-all duration-200"
                onClick={() => setModal && setModal("switch")}
              >
                <Repeat className="w-5 h-5 text-emerald-600" />
                <span className="block w-full text-sm">Switch account</span>
              </DropdownMenuItem>
            )}
            <DropdownMenuItem
              className="flex items-center gap-3 px-3 py-2 cursor-pointer rounded-lg mx-1 my-0.5 text-red-500 hover:bg-red-50 hover:text-red-600 transition-all duration-200"
              onClick={() => logout()}
            >
              <LogOut className="w-5 h-5" />
              <span className="block w-full text-sm font-medium">Logout</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
};

export default AppNavbar;
